export class RequestPollingReportDto {
  code: string;
}

export class RequestReportSendEmailExcelDto {
  code: string;
  emailTo: string;
  fullName: string;
}

export interface ResponseReportSendEmailExcelDto {
  message: string;
  data?: any;
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/survey-service.dto.ts